interface BackendErrorBody {
    code?: string;
    message?: string;
    request_id?: string;
}

export class ApiError extends Error {
    readonly status: number;
    readonly code: string;
    readonly requestId: string | null;

    constructor(status: number, code: string, message: string, requestId: string | null) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
        this.requestId = requestId;
    }

    static async fromResponse(response: Response): Promise<ApiError> {
        let body: BackendErrorBody = {};
        try {
            body = (await response.json()) as BackendErrorBody;
        } catch {
            /* body might be empty or non-JSON */
        }
        return new ApiError(
            response.status,
            body.code ?? `http_${response.status}`,
            body.message ?? response.statusText,
            body.request_id ?? null,
        );
    }
}

export function isApiError(error: unknown): error is ApiError {
    return error instanceof ApiError;
}
